var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex align-center mb-2"},[_c('gl-icon',{attrs:{"height":24,"name":_vm.getIcon,"width":24}}),_c('div',{staticClass:"ml-3 fs-14",class:{'warning-text': !_vm.valid && _vm.turnOn}},[_vm._v(" "+_vm._s(_vm.msg)+" ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }